import { Component, OnInit, ViewEncapsulation,Inject, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { NgForm } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var $:any;

@Component({
  selector: 'app-unstoppable',
  templateUrl: './unstoppable.component.html',
  styleUrls: ['./unstoppable.component.css']
})
export class UnstoppableComponent {

  name: string = "";
  email: string = "";
  mobile: string = "";
  currentAge:string = "";
  nameValidateMessage: any = '';  
  emailValidateMessage: string = '';
  mobileValidateMessage: string = '';
  currAgeValidateMessage:string="";

  intervalId: any;
  timeleft: number=0;
  redirectToPage: string = "";
  clickedResend: number = 0;
  resendBtnTimer = 3;
  isLeadFormVisible: boolean = true;
  isOtpFormVisible: boolean = false;
  isThanksVisible:boolean = false;
  changeMobile: boolean = false;
  userOTP: string = "";
  isTimer: boolean = true;
  isResend: boolean = false;
  displayMobile: string='';
  otpVerifiedStatus: boolean = true;

  visitorId: any;
  leadId: string = '';
 
  otpValidateMessage:string = '';
  
  meta_title:string = '';
  meta_desc:string = '';
  meta_keywords:string = '';
  meta_image: string = '';
  
  hideSuggestion:boolean = false;
  pincode:string = ""; 
  pinValidateMessage:string = '';
  pincodeArr:any[] = [];
  //citycode:string="";

  isResendOTP : boolean=false;
  otpVerify: string = '';

  visitortype: any;

  city:string="";
  cityValidateMsg:string="";

  cityModel = '';
  cityName : string = "Select your city?";
  cityId : number =0;
  cityList : [] = [];

  checkedTerms: string = 'true';

  constructor(@Inject(DOCUMENT) private document: Document,private route: ActivatedRoute,private service: DataService,private titleService: Title, private metaService: Meta, private renderer: Renderer2) { }

  ngOnInit(): void { 
    if (sessionStorage.getItem('visitorId')) {
      this.visitorId = '';
      sessionStorage.setItem('visitorId', '');
    }
    if (sessionStorage.getItem('leadId')) {
      this.leadId = '';
      sessionStorage.removeItem('leadId')
    }
    this.createVisitor();   
    this.getCity(); 
    this.metaForSEO('sapno-ki-udaan');   
  }

  getCity(){
    this.service.cityDropDown().subscribe((data:any)=>{
      this.cityList=data['data'];
    },err=>{
      console.log(err);
    })
  }




  setThumbValue(val:any) {
    
   val = val.replace('₹','');
   var maxval = $('#investedrange').attr('max');
    $('#investedrange').siblings('.thumb').text(val + " ");
    $('#investedrange').siblings('.thumb').css('left', (val * 100) / maxval + '%');
    $('#investedrange').siblings('.type-range').css('width', (val * 100) / maxval + '%');
    $('#exp_monthly_expense').val("₹"+val);

  }



  metaForSEO(slugname: string): void {
    this.service.getDynamicMeta().subscribe(
      (data: any) => {
        const seoPages = data?.rows?.[0]?.seo_pages || [];
  
        seoPages.forEach((v: any) => {
          if (v.seo_slug === slugname || v.seo_slug === "/" + slugname) {
            this.meta_title = v.seo_title;
            this.meta_desc = v.seo_description;
            this.meta_keywords = v.seo_keywords;
  
            this.titleService.setTitle(this.meta_title);
            this.metaService.removeTag('name="keywords"');
            this.metaService.removeTag('name="description"');
            this.metaService.addTags([
              { name: 'keywords', content: this.meta_keywords },
              { name: 'description', content: this.meta_desc },
              { name: 'robots', content: 'index, follow' }
            ]);
          }
        });
      },
      (err) => {
        console.error('Error fetching SEO metadata:', err);
      }
    );
  }
  



  createVisitor() {
    let jscd = window['jscd'];
    if (!sessionStorage.getItem('visitorId')) {
      let obj = {
        "browsername": jscd?.browser,
        "browserversion": jscd?.browser + ' ' + jscd?.browserVersion,
        "operatingsystem": jscd?.os + " " + jscd?.osVersion,
        "device": jscd?.os,
        "sourceurl": window.location.href,
        "productid": '48',
        "visitortype": "unstoppableher",
        "utmsource": this.GetParameterValues("utm_source"),
        "utmmedium": this.GetParameterValues("utm_medium"),
        "leadsource": this.GetParameterValues("lead_source"),
        "utmcampaign": this.GetParameterValues("utm_campaign"),
      };
      this.visitortype = "unstoppableher"; // VISITOR TYPE
      this.service.createVisitor(obj).subscribe((data: any) => {
        this.visitorId = data["visitorId"];
        sessionStorage.setItem('visitorId', data["visitorId"])
      },
        err => {
          console.log(err);
          throw err;
        })
    } else {
      this.visitorId = sessionStorage.getItem('visitorId')
    }
  }

  MobileDisplayLabel(mobile: string) {
   this.displayMobile =`${mobile.substr(0,2)}XXXXX${mobile.substr(7,9)}`;
  }

  
  PostData(leadForm:NgForm){
    document.getElementById('fill-form')!.style.display = 'none';
    console.log('Post')
    this.MobileDisplayLabel(this.mobile);
    this.createLead();
    this.isLeadFormVisible = false;
    this.isOtpFormVisible = true;
    $([document.documentElement, document.body]).animate({
      scrollTop: $("body").offset().top
  });
  
  $("body").addClass('overflow');

    this.isThanksVisible = false;
    this.isTimer = true;
    this.startTimer();
  }

  createLead() {
    let leadid = sessionStorage.getItem('leadId');
    this.visitorId = sessionStorage.getItem('visitorId')
    let obj = {
      "visitorid": this.visitorId,       
      "leadid": leadid ? leadid : 0,
      "name": this.name,
      "mobile": this.mobile,
      "email": this.email,
      "currAge":this.currentAge,
      "pincode":this.pincode,
      "city": this.city      
    }
    this.service.createLead(obj).subscribe((data:any) => {
      sessionStorage.setItem('leadId', data['leadid'])
      this.leadId = data['leadid'];
      // console.log('leadid:', this.leadId);
      this.sendOtp();
      if(!data['success']) {
      }
    }, err => {
      console.log(err);
    })
  }


  sendOtp() {
    this.service.sendOtp({ leadid: this.leadId, mobile: this.mobile }).subscribe(data => {
      console.log("Leadid",this.leadId);
    }, err => {
      console.log(err);
    })
  }

  SubmitOTP(otpForm: NgForm) { 
    this.userOTP = otpForm.value.otp;
    if(this.userOTP){
    this.VerifyOTP();   
    }
    else{
      this.otpValidateMessage = "required";
    }
  }
  

  VerifyOTP() {
    $("#otp_verify_btn").attr("disabled", "true");
    document.getElementById("main_loader")!.style.display = 'block';
    //this.isResend = false;
    this.service.verifyOtp({ leadid: this.leadId, otp: this.userOTP }).subscribe(data => {
      if (data["success"]) {       
        $("#otp_verify_btn").removeAttr("disabled");
        
        document.getElementById("main_loader")!.style.display = 'none';
        sessionStorage.removeItem('leadId')
        let verifystatus = true;
        sessionStorage.setItem('formSubmitted','true');
        this.redirectTo(verifystatus);

        let utm_source=this.GetParameterValues("utm_source");
        let utm_medium=this.GetParameterValues("utm_medium");
        let lead_source=this.GetParameterValues("lead_source");
        let utm_campaign=this.GetParameterValues("utm_campaign");

        
        this.service.pushLeadToLSQ(
          {
            visitor_type: this.visitortype,
            Name: this.name,
            Mobile: this.mobile,
            Email: this.email,
            Campaign_Name:'SapnoKiUdaan' ,
            Landing_Page_URL: window.location.href,
            LEADID: this.leadId,
            Pincode: this.pincode,
            City:this.city,
            Age:this.currentAge,
            Product:"Financial Planning",
            Sub_LeadSource :utm_source ? utm_source : 'Website',
            Utm_Source: utm_source ? utm_source : 'Websites',
            Utm_Medium: utm_medium ? utm_medium : '',
            Utm_Campaign: utm_campaign ? utm_campaign : '',
            LeadSource: 'Digital Marketing',
            Entity_Type: 'Digital_BCL',
          }
        ).subscribe((res:any) => {
          if (res["success"]) {
            let sfid = res['id'];      
          }
        });
        this.leadId = '';

    } else {
      $("#otp_verify_btn").removeAttr("disabled");
      document.getElementById("main_loader")!.style.display = 'none'; 
      sessionStorage.setItem('formSubmitted','false');      
      this.otpVerifiedStatus = false; 
    }
  }, err => {
      $("#otp_verify_btn").removeAttr("disabled");
      console.log(err);
    })
  }

  backbtn(){
    console.log('backbtn')
    this.isLeadFormVisible=true;
    this.isOtpFormVisible=false;
  }

  redirectTo(resp: any) {
    if (resp == true) { 
      this.isThanksVisible = true;     
      $("body").removeClass('overflow');
      this.isLeadFormVisible = false;
      this.isOtpFormVisible = false; 
     }
    else {
      this.otpVerifiedStatus = false;
    }
    
  }


  
  startTimer() {
    clearInterval(this.intervalId);
    this.otpVerifiedStatus = true;
    this.timeleft = 20;
    this.timeleft -= 1;
    this.intervalId = setInterval(() => {
      if (this.timeleft == 0 && this.isOtpFormVisible == true) {
        if (this.clickedResend === this.resendBtnTimer) {
          this.isResend = false;
        }
        if (this.clickedResend > 0 && this.clickedResend < this.resendBtnTimer) {
          this.isResend = true;
        }
        this.isTimer = false;
        clearInterval(this.intervalId);       
        if (this.clickedResend == 0) {          
          this.isResend = true;
        }
      }
      this.timeleft -= 1;
    }, 1000);
  }

  
  resendOTP() {
    $("#otp_verify_btn").removeAttr("disabled");    
    //this.leadForm.controls['otp'].reset();
    this.userOTP = "";
    this.clickedResend++;
    this.isResendOTP=true;
    this.sendOtp();
    //this.leadForm.setErrors(null);
    this.startTimer();
    this.isTimer = true;
    this.isResend= false;
  }

  changeNumber() {
    $("#otp_verify_btn").removeAttr("disabled");
    this.userOTP = "";
    this.clickedResend = 0;
    this.changeMobile = true;
    this.isResend = false;
    this.isTimer = false; // to hide timer  
    // this.leadForm.setErrors({ 'incorrect': true });
    this.isLeadFormVisible = true;
    this.isOtpFormVisible = false;
    this.mobile = "";
  }

  removeErrorMsg(fieldname:string) {
    if(fieldname == "otp"){
      this.otpValidateMessage = "";
      this.otpVerifiedStatus = true; // to remove Invalid OTP message
    }
    if (fieldname=="name") {
      this.nameValidateMessage = "";
    }
    if (fieldname=="email") {
      this.emailValidateMessage = "";
    }
    if (fieldname=="mobile") {
      this.mobileValidateMessage = "";
    }
    if (fieldname=="currentage") {
      this.currAgeValidateMessage = "";
    }
    if (fieldname=="city") {
      this.cityValidateMsg = "";
    }

  }
  

  checkValidationMsg(leadForm:NgForm) {  
    console.log('Checking')
    let num: number = 0;
    this.name = leadForm.value.name.trim();
    this.email = leadForm.value.email.trim();
    this.mobile = leadForm.value.mobile.trim();     
    this.currentAge = leadForm.value.currentAge.trim();

    this.pincode = leadForm.value.pincode.trim();
    this.city = leadForm.value.city.trim();
    
    if (this.name && this.name.length < 3) {
      this.nameValidateMessage = "lengthError";
      num += 1;
    }
    if (!this.name) {
      this.nameValidateMessage = "required";
      num += 1;
    }
    if (this.email && this.validateEmailAddress(this.email) == 0) {
      this.emailValidateMessage = "invalid";
      num += 1;
    }
    if(!this.email){  
          this.emailValidateMessage = "required";
          num+=1;
    }
    if (this.isMobileWrong(this.mobile) == 0) {
      this.mobileValidateMessage= "invalid";
      num += 1;
    }
    if (!this.mobile) {
      this.mobileValidateMessage = "required";
      num += 1;
    }
    if (this.mobile && this.mobile.length != 10) {
      this.mobileValidateMessage = "lengthError";
      num += 1;
    }

    if(!this.pincode){  
      this.pinValidateMessage = "required";
      num+=1;
    }
    if(this.pincode && this.pincode.length!=6 ){  
      this.pinValidateMessage = "invalid";
      num+=1;
    }
    if(this.pincodeArr.length == 0){
      this.pinValidateMessage = "invalid";
      num+=1;
    }

    if (!this.city) {
      this.cityValidateMsg = "required";
      num += 1;
    }
    
    // city dropdown
    // if (!this.cityId) {
    //   this.cityValidateMsg = "required";
    //   num += 1;
    // }

    if(!this.currentAge){  
      this.currAgeValidateMessage = "required";
      num+=1;
    }
    if (parseInt(this.currentAge)<18 || parseInt(this.currentAge)>99) {     
      this.currAgeValidateMessage="invalid";
      num += 1;   
    }

    if (num > 0) {
      return false;
    }else{
      return true;
    }
  }


  
  otpValidate(){
    console.log('otpValidate')
    let num: number = 0;
    if (this.userOTP && this.userOTP.length != 6) {
      this.otpValidateMessage = "lengthError";
      num += 1;
    } 
    if (num > 0) {
      return false;
    }
    return;
  }
  
  validateEmailAddress(email:string) {    
    if (email) {
      var lastChars = email.lastIndexOf(".");
      var expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
      if (!expression.test(String(email).toLowerCase()) || email.substring(lastChars, 3).length < 3) {
        return 0;
      }
      else {
        return 1;
      }
    }
    return
  }

  isMobileWrong(mobile:string) {
    let firstDigit = mobile.substring(0, 1);
    if (firstDigit != '6' && firstDigit != '7' && firstDigit != '8' && firstDigit != '9') {
      return 0;
    }
    else if (mobile.match(/^(\d)\1+$/g)) {
      return 0;
    }
    else {
      return 1;
    }
  } 


  openSuggestionBox(event: Event, flag: string) {
    const target = event.target as HTMLInputElement | null;
    if (target && target.value.length > 0) { // Ensure target is not null
      if (flag === 'form') {   
        this.hideSuggestion = true;
      }
    }
  }

  hideSuggestionDiv(flag:string){
    if(flag == 'form'){
      this.hideSuggestion = false;
      if(this.pincode){
        this.pinValidateMessage = "";
        }
    }
   }

   getPincodeList(event: Event, flag: string) {
    const pincode = (event.target as HTMLInputElement).value; // Safely access the value of the input
    if (flag === 'form') {    
      if (pincode.length <= 3) {
        this.hideSuggestion = false;
      }
      this.service.cityFiler(pincode).subscribe((response: any) => {
        if (pincode.length > 3) {
          this.hideSuggestion = true;
          this.pincodeArr = response['data']; // pincode | citycode | cityname
          if (this.pincodeArr.length === 0) {
            this.pinValidateMessage = "invalid";          
          }
        }
      })
    }
  }
  
  setpincode(pinObj:any,flag:string){  
    if(flag == 'form')
    {    
     //this.citycode = pinObj.citycode;
      this.pincode = pinObj.pincode;   
      this.hideSuggestion = false;
    }
  }

 alphaOnly(event:any) {
    var key = event.keyCode;
   return ((key >= 65 && key <= 90) || (key == 8 || key == 32));
 };

 numbersOnly($event: any) {
  if ($event.target.value.length === 0) {
    if ($event.key === '0' || $event.key === '1' || $event.key === '2' || $event.key === '3' || $event.key === '4' || $event.key === '5') {
      return false;
    }
  }
  var reg = /^[0-9]+$/;
  return (reg.test($event.key));
};

numberspincode($event: any) {
  if ($event.target.value.length === 0) {
    if ($event.key === '0') {
      return false;
    }
  }
  var reg = /^[0-9]+$/;
  return (reg.test($event.key));
};

numbersOnlyotp($event: any) {
  return /^[0-9]$/.test($event.key);
};

GetParameterValues(param: string) {
  var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < url.length; i++) {
    var urlparam = url[i].split('=');
    if (urlparam[0] == param) {
      return urlparam[1];
    }
  }
  return
}

scroll(){
  window.scrollTo({ top: 0, behavior: 'smooth' });
  document.getElementById('fill-form')!.style.display = 'block';
}

desktopscroll(){
  document.getElementById('fill-form')!.style.display = 'block';
}
// city dropdown
ValidateCity(){
  if(this.cityModel === ''){
    this.cityValidateMsg = 'required';
   
  }else{
   let values = this.cityModel.split("-");
   this.cityName = values[0];
   this.cityId = parseInt(values[1]);    
   if(this.cityId)
   this.cityValidateMsg = 'validate';
  }
 }

}